'use client'

import { useIntl } from 'react-intl'
import { InfoBanner, Spacer } from '@vinted/web-ui'

import {
  AccountRestrictionAction,
  AccountRestrictionDto,
  SELLING_RESTRICTION_URL,
} from '@marketplace-web/user-restrictions/user-restrictions-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  accountRestriction?: AccountRestrictionDto
}

const ProfileSellingRestrictionBanner = ({ accountRestriction }: Props) => {
  const translate = useTranslate('selling_restriction.info_banner')

  const { formatDate } = useIntl()

  const getFormattedDate = () => {
    if (!accountRestriction) return undefined

    const date = new Date(accountRestriction.expiration_date)

    const formattedDate = formatDate(date, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })

    return formattedDate.replace(/-/g, ' ')
  }

  const formattedDate = getFormattedDate()

  if (!accountRestriction || accountRestriction.action !== AccountRestrictionAction.Selling)
    return null

  return (
    <>
      <InfoBanner
        type={InfoBanner.Type.Warning}
        title={translate('title', {
          date: formattedDate,
        })}
        body={translate('description', {
          date: formattedDate,
          'link-learn-more': chunks => (
            <a key={SELLING_RESTRICTION_URL} href={SELLING_RESTRICTION_URL}>
              {chunks}
            </a>
          ),
        })}
      />
      <Spacer />
    </>
  )
}

export default ProfileSellingRestrictionBanner
